import { displayToast } from '../../../../helpers/notification';
import { FeaturedContentTypes as Type } from '../../../types/featuredcontent';

export function addFeaturedContentRequest(body: any) {
  return {
    type: Type.ADD_FEATURED_CONTENT_REQUEST,
    body,
  };
}

export function addFeaturedContentRequestSuccess(data: any) {
  return {
    type: Type.ADD_FEATURED_CONTENT_REQUEST_SUCCESS,
    payload: data,
  };
}

export function addFeaturedContentRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.ADD_FEATURED_CONTENT_REQUEST_FAILURE,
    error: error,
  };
}

export function restAddFeaturedContentRequest() {
  return {
    type: Type.RESET_ADD_FEATURED_CONTENT_REQUEST,
  };
}
